import { Dispatch } from 'react';
import { networkCall, apiBaseUrl } from '../../utils/networkCall';
import isEmpty from 'lodash/isEmpty'; 
import { COUNTRY_LOADING, COUNTRY_SUCCESS, COUNTRY_FAILED, COUNTRY_CLEAR } from './country.action';

export const FETCH_PRICING_LOADING = "FETCH_PRICING_LOADING";
export const FETCH_PRICING_SUCCESS = "FETCH_PRICING_SUCCESS";
export const FETCH_PRICING_FAILED = "FETCH_PRICING_FAILED";
export const CLEAR_PRICING_DETAILS = "CLEAR_PRICING_DETAILS";

export const FETCH_ALL_SERVICES_COUNTRY_LOADING = "FETCH_ALL_SERVICES_COUNTRY_LOADING";
export const FETCH_ALL_SERVICES_COUNTRY_SUCCESS = "FETCH_ALL_SERVICES_COUNTRY_SUCCESS";
export const FETCH_ALL_SERVICES_COUNTRY_FAILED = "FETCH_ALL_SERVICES_COUNTRY_FAILED";

export const fetchPricingDetails = (type:string) => {
    return (dispatch:Dispatch<any>) => {

        dispatch({type: FETCH_PRICING_LOADING});

        let data = {
            services: [type],
            send_full_list: true
        }
        networkCall("post", `/price`, apiBaseUrl.baseUrl, true, true, data)
        .then((res:any)=>{
            if(res.error && isEmpty(res.error)){
                dispatch({type: FETCH_PRICING_SUCCESS, payload: {res: res}});
            }else{
                dispatch({type: FETCH_PRICING_FAILED, payload: {error: res}});
            }
        }).catch((error:any)=>{
            if(error?.response?.data){
                dispatch({ type: FETCH_PRICING_FAILED, payload: {error: error.response.data}});
            }
        });
    }
}

export const fetchPricingCountries = (type:string) => {
    return (dispatch:Dispatch<any>) => {
        dispatch({type: COUNTRY_LOADING});
        networkCall("get", `/${type}/supported-countries`, apiBaseUrl.baseUrl)
        .then((res:any)=>{
            if(res.error && isEmpty(res.error)){
                dispatch({type: COUNTRY_SUCCESS, payload: {res: res}});
            }else{
                dispatch({type: COUNTRY_FAILED, payload: {error: res}});
            }
        }).catch((error)=>{
            if(error?.response?.data){
                dispatch({ type: COUNTRY_FAILED, payload: {error: error.response.data}});
            }
        });
    }
}

export const fetchAllServicesPricingCountries = () => {
    return (dispatch:Dispatch<any>) => {
        dispatch({type: FETCH_ALL_SERVICES_COUNTRY_LOADING});
        networkCall("get", `/all-service/supported-countries`, apiBaseUrl.baseUrl)
        .then((res:any)=>{
            if(res.error && isEmpty(res.error)){
                dispatch({type: FETCH_ALL_SERVICES_COUNTRY_SUCCESS, payload: {res: res}});
            }else{
                dispatch({type: FETCH_ALL_SERVICES_COUNTRY_FAILED, payload: {error: res}});
            }
        }).catch((error)=>{
            if(error?.response?.data){
                dispatch({ type: FETCH_ALL_SERVICES_COUNTRY_FAILED, payload: {error: error.response.data}});
            }
        });
    }
}

export const clearPricingDetails = () => {
    return (dispatch:Dispatch<any>) => {
        dispatch({type: CLEAR_PRICING_DETAILS});
        dispatch({type: COUNTRY_CLEAR});
    }
}